import { combineReducers } from '@reduxjs/toolkit'

import { REDUCER_INDEX } from '../constants'
import { reducer as list } from '../redux/list'
import team from './team'

const reducer = combineReducers({
  list,
  team,
})

export const registerReducer = (state) => ({
  ...state,
  [REDUCER_INDEX]: reducer,
})

export const getState = (state) => state[REDUCER_INDEX]
export const getStateTeam = (state) => state[REDUCER_INDEX].team

export default reducer
